import React from 'react';
import { Container, Title, Paper, Text } from '@mantine/core';

export const TwoFactorPage: React.FC = () => {
  return (
    <Container size="xl">
      <Paper withBorder p="xl">
        <Title order={2} mb="md">Two-Factor Authentication</Title>
        <Text c="dimmed">Manage 2FA settings and recovery codes.</Text>
      </Paper>
    </Container>
  );
};